<ion-header no-border mode="md">
    <ion-toolbar color="primary" mode="md">
        <ion-title>
            {{ 'notifications.title' | translate }}
        </ion-title>
        <ion-buttons slot="end">
            <ion-button color="light" (click)="dismiss()" mode="ios">
                <ion-icon class="bp-close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>


<ion-content class="content">
    <div *ngIf="notificationsView.length == 0" style="display: flex;justify-content: center;align-items: center;height: 100%;">
        <p>{{ 'notifications.noNotifications' | translate }}</p>
    </div>
    <ion-list *ngIf="notificationsView.length > 0">
        <ion-item *ngFor="let notification of notificationsView">
            <div>
                <div class="notification-title-container" (click)="toggleNotificationDetail(notification)">
                    <h2 
                        class="notification-title"
                        [ngClass]="{'notification-not-read': !notification.isRead}"
                        >
                    {{ notification.globalizationConfig[selectedLanguage].title || notification.title }}
                    </h2>
                    <div style="display: flex;align-items: center;gap: 5px;">
                        <p class="notification-date">{{ notification.createdAt | date: 'dd/MM/yyyy' }}</p>
                        <ion-icon color="primary"
                            slot="icon-only" [src]="notification.isDetailOpen? '/assets/icon/chevron-down.svg' : '/assets/icon/chevron-up.svg'" ></ion-icon>
                    </div>
                </div>
              
                <br/>
                <p *ngIf="notification.isDetailOpen" class="notification-body" [innerHtml]="notification.globalizationConfig[selectedLanguage].content || ''"></p>  
            </div>
            
        </ion-item>
        <div style="display: flex;align-items: center;justify-content:center;" *ngIf="currentNotificationPage < notificationLastPage">
            <ion-button color="primary" fill="solid" mode="ios" (click)="loadMoreNotifications()" [disabled]="isLoadingMessages">
                {{ isLoadingMessages? 'Loading...': ('generic.loadMore' | translate) }}
            </ion-button>
        </div>
    </ion-list>
</ion-content>